import { render, staticRenderFns } from "./participant-details-medication.vue?vue&type=template&id=3cc0cffb&scoped=true"
import script from "./participant-details-medication.vue?vue&type=script&lang=js"
export * from "./participant-details-medication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0cffb",
  null
  
)

export default component.exports